import { Module }    from 'vuex';
import { RootState } from '@/store/store.types';
import actions       from '@/views/calendar-configuration/store/calendar-configuration.actions';
import mutations     from '@/views/calendar-configuration/store/calendar-configuration.mutations';
import state         from '@/views/calendar-configuration/store/calendar-configuration.state';
import { State }     from '@/views/calendar-configuration/calendar-configuration.types';

const store: Module<State, RootState> = {
  namespaced: true,
  actions,
  mutations,
  state,
};

export default store;
